import { GridColDef } from "../../../Unknown/DataGrid";
import { AppointmentColumnItemCoupon, AppointmentRowItem } from "../types";
import { DEFAULT_COLUMN_MIN_WIDTH } from "../../../../common/constants";

export type ColumnCouponTranslations = {
  columnCoupon: string;
};

const getColumnCoupon = (params: {
  columnItem: AppointmentColumnItemCoupon;
  translations: ColumnCouponTranslations;
}): GridColDef<AppointmentRowItem, string> => {
  const { columnItem, translations } = params;

  return {
    field: columnItem.field,
    disableColumnMenu: true,
    flex: 1,
    minWidth: DEFAULT_COLUMN_MIN_WIDTH,
    headerName: translations.columnCoupon,
    valueGetter: (getterParams) => {
      const { couponCode } = getterParams.row;

      return couponCode || "";
    },
  };
};

export default getColumnCoupon;
